import { DsMessageModule, DsMessageTone } from '@bmw-ds/components';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-api-ds-message',
  standalone: true,
  imports: [CommonModule, DsMessageModule],
  template: ` <div *ngIf="messageVisible">
    <ds-message
      [tone]="messageTone"
      [isDismissable]="true"
      [messageText]="messageText"
    >
    </ds-message>
  </div>`,
  styleUrls: [],
})
export class ApiDsMessageComponent {
  messageVisible = false; // default false — hidden until triggered
  messageTone: DsMessageTone = 'critical';
  messageText = '';

  // Call this to show an error message
  showError(message: string, tone: string): void {
    this.messageText = message;
    this.messageTone = tone as DsMessageTone;
    this.messageVisible = true;
    setTimeout(() => {
      this.messageVisible = false;
      this.messageText = '';
    }, 5000); // auto-hide after 5 seconds
  }
}
